import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Link, StringOrObjectUrl } from "app/core/white-label/white-label.type";
import { WhiteLabelService } from "app/core/white-label/white-label.service";
import { LanguageService } from "app/core/services/language.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { NgClass, NgIf } from "@angular/common";
import { SvgComponent } from "app/shared/components/svg/svg-icon/svg-icon.component";
import { TranslateModule } from "@ngx-translate/core";

/**
 * The component is needed to separate the logic (desktop app/web app) for opening
 * a regular link in new browser window
 */
@Component({
  selector: "app-link",
  standalone: true,
  templateUrl: "./link.component.html",
  styleUrls: ["./link.component.scss"],
  imports: [NgClass, SvgComponent, TranslateModule, NgIf],
  providers: [WhiteLabelService, LanguageService],
})
export class LinkComponent implements OnInit, OnChanges, OnDestroy {
  private language: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @Input() public link: Link;
  @Input() public customClass: string = "default";
  @Input() public e2e: string;
  public linkByLanguage: Link;
  public isCookieBannerLink: boolean = false;

  constructor(
    private whiteLabelService: WhiteLabelService,
    private languageService: LanguageService,
  ) {
    this.linkByLanguage = { ...this.link };
  }

  public ngOnInit(): void {
    this.languageService.languageChange$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.setLink();
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.link) {
      this.setLink();
    }
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public setLink(): void {
    this.language = this.languageService.getCurrentLanguage();
    this.isCookieBannerLink = this.link.name === "Datenschutzhinweisen";
    Object.assign(this.linkByLanguage, this.link);
    this.linkByLanguage = this.whiteLabelService.getLinkForLanguage(
      this.linkByLanguage,
      this.language,
    );
  }

  public openUrl(url: StringOrObjectUrl): boolean {
    if (typeof url === "string") {
      window.open(url, "_blank");
    }
    return false;
  }
}
